import React from 'react';
import AmcqResultsView from '../../Teachers/Results/TeacherStudentView/AmcqResultsView';

function StudentResultsAMCQ() {
  return <AmcqResultsView userType="student" />;
}

export default StudentResultsAMCQ;
